<template>
     <div class="modal-overlay" v-show="AddLocationModal">
    <Modal class="custom-modal custom-modal-width2" v-show="AddLocationModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="loader-container" v-if="isAddingLocation">
          <div class="center-content3">
            <div style="margin-bottom: 300px; font-size: 12px; color: #000;">
        <center><div class="loader2" style="margin-bottom: 15px;"></div></center>
        <p>Adding Location to Business...</p>
      </div>
    </div>
      </div>
      <div v-else>
          <div class="modal-header">
            <button type="button" class="close" @click="CloseAddLocationModal">
              <span aria-hidden="true">&times;</span>
            </button>
            </div>
            <div class="modal-header">
            <div class="modal-header-container">
                <div class="modal-header-text2">
                    Add Location for {{ BusinessName }}<br>
                    <div class="modal-text3">Please provide all information requested below in order to</div>
                    <div class="modal-text3">add location to the business.</div>
                </div>
              </div>
            </div>
        <form @submit.prevent="addLocation">


        <div class="modal-body modal-body9 modal-text">

            <!-- Location Name -->
            <div class="form-group">
            <label for="locationName">Location Name</label>
            <div class="dropdown-container">
              <input type="text" id="locationName" class="form-control" required v-model="locationName" placeholder="Enter location name" style="font-size: 12px; background-color: #F8F9FC"><br>
            </div>
            <div class="modal-text3">E.g Town or City</div>
          </div>


            <!-- Location Address -->
            <div class="form-group">
            <label for="locationAddress">Location Address</label>
            <div class="dropdown-container">
              <input type="text" id="locationAddress" required class="form-control" v-model="locationAddress" placeholder="Enter location address" style="font-size: 12px; background-color: #F8F9FC"><br>
            </div>
            <div class="modal-text3">E.g house number and street</div>
          </div>

          <!-- State -->
        <div class="form-group">
          <label for="state">State</label>
          <div class="dropdown-container">
            <select
              id="state"
              class="form-control"
              v-model="selectedState"
              required
              @change="updateLGAs"
              style="font-size: 12px; background-color: #F8F9FC"
            >
              <option value="" disabled selected>Select state</option>
              <option v-for="state in states" :key="state.id" :value="state.id">{{ state.name }}</option>
            </select>
            <div class="dropdown-icon-container">
              <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon">
            </div>
          </div>
        </div>

    <!-- LGA -->
        <div class="form-group">
          <label for="lga">LGA</label>
          <div class="dropdown-container">
            <select
              id="lga"
              class="form-control"
              v-model="selectedLGA"
              required
              @change="getLGAName"
              style="font-size: 12px; background-color: #F8F9FC"
            >
              <option value="" disabled selected>Select LGA</option>
              <option v-for="lga in selectedStateLGAs" :key="lga.id" :value="lga.id">{{ lga.name }}</option>
            </select>
            <div class="dropdown-icon-container">
              <img src="@/components/img/Sales_Assests/dropdown.svg" alt="Dropdown Icon">
            </div>
          </div>
        </div>

          </div>

          <div class="modal-footer">
            <div class="button-container" style="width: 100%;" >
            <button class="onboard-button2" type="submit" style="width: 100%; height: 40px;"> Add Location</button>
            </div>
          </div>
        </form>
        </div>
        </div>
      </div>
    </Modal>
  </div>
          
        
        </template>
        
        <script>
        //  import axios from 'axios';
        import axios from 'axios';
    // import debounce from 'lodash/debounce';
        
          
        export default {
          props:  ['AddLocationModal', 'BusinessID', 'BusinessName'],
        
          data() {
          return {
            DataLoading: true,
            isAddingLocation: false,
            states: [],
            selectedState: '',
            selectedStateName: '',
            selectedStateLGAs: [],
            selectedStateLGAName: '',
            selectedLGA: '',
            locationName: '',
            locationAddress: '',
            state: '',
            lga: '',
          }
        },

      async mounted() {
        try{
        await  this.fetchStates();
        this.DataLoading = false;
        }catch (error) {
        this.DataLoading = false;
        console.error(error);
        // this.$toast.open({
        // message: error,
        // type: 'error',
        // duration: 3000,
        // });
        }
        },   
        methods: {

          async addLocation() {
          this.isAddingLocation = true;
          try {

          const payload = {
            businessAddress: this.locationAddress,
            locationName: this.locationName,
            state: this.selectedStateName,
            lga: this.selectedStateLGAName
          }
          const response = await axios.post(`${this.$config.GETMERCHANT_ENDPOINT}/${this.BusinessID}/add-location`, payload)
          
          if(response.status == 200){
            this.$toast.open({
          message: 'Location has been Added Successfully',
          type: 'success',
          duration: 3000,
          });
          this.$emit('reload-business');
          this.CloseAddLocationModal();
          this.isAddingLocation = false;
          // Clear the form fields
          this.locationAddress = '';
          this.locationName = '';
          this.selectedState = '';
          this.selectedLGA = '';
          }

        }catch(error){
          this.isAddingLocation = false;
          console.log('Unable to Add Location to Business',error);
          this.$toast.open({
          message: 'Unable to Add Location to Business',
          type: 'warning',
          duration: 3000,
          });
        }
  },

            CloseAddLocationModal(){
            this.$emit('close-add-location-modal');
            },
    
            async fetchStates() {
      try {
        const response = await axios.get(this.$config.GETALLSTATE_ENDPOINT);
        this.states = response.data.data;
      } catch (error) {
        console.error(error);
      }
    }, 

    getLGAName() {
      const selectedLGA = this.selectedStateLGAs.find(lga => lga.id === this.selectedLGA);
      if (selectedLGA) {
        this.selectedStateLGAName = selectedLGA.name;
      } else {
        this.selectedLGA = [];
      }
    },

    updateLGAs() {
      const selectedState = this.states.find(state => state.id === this.selectedState);
      if (selectedState) {
        this.selectedStateLGAs = selectedState.lga;
        this.selectedStateName = selectedState.name;
      } else {
        this.selectedStateLGAs = [];
      }
    },
        }
        
        }
        
        </script>
        
        <style scoped>
    
    .location-card7 {
      border-radius: 3px;
      margin-bottom: 10px;
      padding: 10px;
      display: flex;
      align-items: center;
      background-color: #F1F3F9;
      height: 40px;
    }
         .table1 {
        width: 100%;
        border-collapse: collapse;
    
        th, td {
        padding: 2px;
        text-align: left;
      }
    
      td{
        font-weight: bold;
        color: #212020;
        font-size: 13px;
      }
      
      th {
        width: auto;
        font-size: 12px;
        color: #b0a8a8;
        font-weight: normal;
      }
      }
    
        .location-detail-card{
            height: 200px;
            width: 415px;
            border: 1px solid #000;
            border-radius: 5px;
            background-color: #FFF9ED;
            padding: 15px;
        }
        
        .modal-body-detail {
          max-height: 350px;
          overflow-y: auto;
        }
        
        .tab-buttons2 {
          display: flex;
          margin-bottom: 15px;
        }
        
        .tab-buttons2 button {
          background-color: transparent;
          border: none;
          cursor: pointer;
          font-size: 14px;
          margin-right: 10px;
          padding: 10px;
          color: #b0a8a8;
          width: 140px;
          height: 30px;
          font-size: 13px;
        }
        
        .tab-buttons2 button.activeTab {
          border-bottom: 2px solid #6F48FF; /* Active tab indicator color */
          color: #000; /* Active tab text color */
          font-weight: bold;
        }
        
        </style>